import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { jsPDF } from 'jspdf';
import { Canvg } from "canvg";
import html2canvas from "html2canvas";
import { EstimateDetailsDownloadService } from './estimate-details-download-service';
import { Loading } from '../loading/loading';

@Component({
  selector: 'estimate-details-download',
  imports: [CommonModule, FormsModule, MatIconModule,Loading],
  standalone: true,
  templateUrl: './estimate-details-download.html',
  styleUrl: './estimate-details-download.scss'
})
export class EstimateDetailsDownload implements OnInit {
  regNumber: string = '';
  selectedMake: string = '';
  selectedModel: string = '';
  selectedYear: string = '';
  fuelType: string = '';
  variant: string = '';
  garageName: any;
  garageContact: any;
  garageLocation: any;
  partsInformation: any;
  laboursInformation: any[] = [];
  whatsIncluded: any;
  customerName: string = '';
  customerPhoneNumber: string = '';
  loading = false;
  serviceKitName: any;
  serviceKitDescription: any;
  customerNameDetail: string = '';
  customerPhoneDetail: string = '';
  customerEmailDetail: string = '';
  partsTotal: number = 0;
  labourTotal: number = 0;
  estimatedTotal: number = 0;



  constructor(private downloadService: EstimateDetailsDownloadService) {const nav = history.state;
  this.customerName = nav.customerName || '';
  this.customerPhoneNumber = nav.customerPhoneNumber || '';}

  ngOnInit() {
    this.callDownloadPdfApi();
  }

  // callDownloadPdfApi() {
  //   this.downloadService.downloadPdfDetails().subscribe({
  //     next: (response: any) => {
  //       console.log('estimate-details-download-response:', response);

  //       if (response && response.code === 200 && response.data) {
  //         const data = response.data;

  //         // Garage details
  //         if (data.garageDetail) {
  //           const garage = data.garageDetail;
  //           this.garageName = garage.name || this.garageName;
  //           this.garageContact = `📞 +91 ${garage.number || 'N/A'} | ${garage.email || 'N/A'}`;
  //           this.garageLocation = `📍 ${garage.address || 'N/A'}`;
  //         }

  //         // Vehicle details
  //         if (data.vehicleDetail) {
  //           const vehicle = data.vehicleDetail;
  //           this.regNumber = vehicle.registrationNumber || this.regNumber;
  //           this.selectedMake = vehicle.make || this.selectedMake;
  //           this.selectedModel = vehicle.model || this.selectedModel;
  //           this.selectedYear = vehicle.year ? vehicle.year.toString() : this.selectedYear;
  //           this.fuelType = vehicle.fuelType || this.fuelType;
  //           this.variant = vehicle.variant || this.variant;
  //         }

  //         // Parts information
  //         if (data.partsInformation) {
  //           this.partsInformation = data.partsInformation;
  //         }
          
  //         if (data.laboursInformation) {
  //           this.laboursInformation = data.laboursInformation;
  //         }
  //         if(data.whatsIncluded){
  //           this.whatsIncluded = data.whatsIncluded
  //         }
  //         // Other fields can also be handled here if needed
  //       }
  //     },
  //     error: (error: any) => {
  //       console.error('API call error:', error);
  //     }
  //   });
  // }

  callDownloadPdfApi() {
    this.loading=true;
    this.downloadService.downloadPdfDetails(
      this.customerName,
      this.customerPhoneNumber
    ).subscribe({
      next: (response: any) => {
        console.log('estimate-details-download-response:', response);

        if (response && response.code === 200 && response.data) {
          const data = response.data;
          this.loading=false;

          if (data.garageDetail) {
            const garage = data.garageDetail;
            this.garageName = garage.name || this.garageName;
            this.garageContact = `📞 +91 ${garage.number || 'N/A'} | ${garage.email || 'N/A'}`;
            this.garageLocation = `📍 ${garage.address || 'N/A'}`;
          }

          if (data.vehicleDetail) {
            const vehicle = data.vehicleDetail;
            this.regNumber = vehicle.registrationNumber || this.regNumber;
            this.selectedMake = vehicle.make || this.selectedMake;
            this.selectedModel = vehicle.model || this.selectedModel;
            this.selectedYear = vehicle.year ? vehicle.year.toString() : this.selectedYear;
            this.fuelType = vehicle.fuelType || this.fuelType;
            this.variant = vehicle.variant || this.variant;
          }

          if (data.serviceKitDetail) {
            this.serviceKitName = data.serviceKitDetail.name || '';
            this.serviceKitDescription = data.serviceKitDetail.description || '';
          }
        if (data.customerDetail) {
            this.customerNameDetail = data.customerDetail.customerName || '';
            this.customerPhoneDetail = data.customerDetail.customerPhoneNumber || '';
          }


          if (data.partsInformation) {
            this.partsInformation = data.partsInformation;
          }

          if (data.laboursInformation) {
            this.laboursInformation = data.laboursInformation;
          }

          if (data.whatsIncluded) {
            this.whatsIncluded = data.whatsIncluded;
          }
          // Calculate Parts Total
          if (data.partsInformation && data.partsInformation.length) {
            this.partsTotal = data.partsInformation.reduce((sum: number, p: any) => {
              return sum + (p.zohoPartPrice || 0);
            }, 0);
          }

          // Calculate Labour Total
          if (data.laboursInformation && data.laboursInformation.length) {
            this.labourTotal = data.laboursInformation.reduce((sum: number, l: any) => {
              return sum + (l.labourRate || 0);
            }, 0);
          }

          // Calculate Estimated Total
          this.estimatedTotal = this.partsTotal + this.labourTotal;

        }
      },
      error: (error: any) => {
        console.error('API call error:', error);
      }
    });
}

downloadPDF() {
  this.loading = true;

  setTimeout(() => {
    const element = document.querySelector('.estimate-download-mainpage') as HTMLElement;

    html2canvas(element, { scale: 2 }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = 210;
      const pageHeight = 297;

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * pageWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save('estimate-details.pdf');
      this.loading = false;
    }).catch(err => {
      console.error("PDF generation error:", err);
      this.loading = false;
    });

  }, 100);
}


}
